var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sn-select',{staticClass:"sn-select-wrapper",class:{
    'open': _vm.open,
    'approved': _vm.data.isValid === true,
    'alert': _vm.data.hasAlert,
    'invalid': _vm.data.isValid === false
  },attrs:{"display-type":_vm.propertyData.displayType,"disabled":_vm.disabled,"options":_vm.options,"active-options":_vm.initialOptions,"label":_vm.label,"label-key":_vm.label,"settings":_vm.propertyData,"selection-width":_vm.width,"subtitle-key":_vm.propertyData.subtitleKey},on:{"selectionChanged":_vm.updateValue,"isOpen":_vm.updateOpen}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198fe94a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/components/Inputs/Selection/SNSelectWrapper.vue
// module id = null
// module chunks = 